import script from "./LoginUserAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginUserAvatar.vue?vue&type=script&setup=true&lang=js"

import "./LoginUserAvatar.vue?vue&type=style&index=0&id=f54d8660&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f54d8660"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QBadge,QAvatar,QImg,QMenu,QItem,QCard,QSeparator});
